import * as React from "react";

/**
 * Returns the passed in values, EXCEPT when it goes to undefined, in which case the old
 * value is returned.
 */
export function useStickyValue<T>(inputValue: T | undefined): T | undefined {
  return useResettableStickyValue(inputValue)[0];
}

export function useResettableStickyValue<T>(
  inputValue: T | undefined,
): [T | undefined, { reset: () => void }] {
  const [stickyValue, setStickyValue] = React.useState(inputValue);

  React.useEffect(() => {
    if (inputValue !== undefined && inputValue != null) {
      setStickyValue(inputValue);
    }
  }, [inputValue]);

  const reset = React.useCallback(() => {
    setStickyValue(undefined);
  }, []);

  // Return inputValue if it's set, otherwise the sticky value. NB: We don't want to lag
  // the signal, hence also consider inputValue (first version used to just return
  // stickyValue...).
  return [inputValue || stickyValue, { reset }];
}
